<template>
  <v-list class="my-0 py-0" dense expand>
    <v-list-group
      :key="index"
      :no-action="!singleRule"
      append-icon=""
      v-for="(rule, index) in passRules"
      v-model="rule.active"
    >
      <v-list-tile slot="activator">
        <v-list-tile-action-text
          class="mx-3"
          v-if="!singleRule">
          <span v-if="specific">{{rule.vehicle.plate}}</span>
          <span v-else>{{prefixText}} {{index + 1}}</span>
        </v-list-tile-action-text>
        <v-list-tile-content>
          <v-list-tile-title :class="singleRule? 'pl-2':''" class="body-1">
            <span class="caption grey--text pr-2 hidden-sm-and-down">开始时间</span>
            <span>{{ rule.startDatetime }}</span>
            <span class="mx-2">{{$vuetify.breakpoint.smAndDown ? '-' : ''}}</span>
            <span class="caption grey--text pr-2 hidden-sm-and-down">结束时间</span>
            <span>{{ rule.endDatetime }}</span>
            <span class="mx-2"></span>
            <span>{{rule.ruleType === 'sectional' ? '时段型':'周期型'}}</span>
            <span class="mx-2" v-if="rule.ruleType === 'periodic'"></span>
            <span v-if="rule.ruleType === 'periodic'">{{rule.period === 'day'? '按天循环':'按周循环'}}</span>
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action v-if="specific && rule.isStandalone">
          <v-tooltip left>
            <v-icon
              small
              :class="'amber--text'"
              slot="activator">$vuetify.icons.standalone</v-icon>
            <span>单独执行</span>
          </v-tooltip>
        </v-list-tile-action>
        <v-list-tile-action>
          <slot :index="index" :item="rule" name="action"></slot>
        </v-list-tile-action>
      </v-list-tile>
      <template v-if="rule.ruleType === 'periodic' ">
        <v-list-group
          :key="index"
          append-icon=""
          no-action
          :sub-group="!noIdent"
          v-for="(slice, index) in rule.slices"
          v-model="slice.active"
        >
          <v-list-tile slot="activator">
            <v-list-tile-action-text class="mr-3 ml-2">
              时间片 {{index+1}}
            </v-list-tile-action-text>
            <v-list-tile-content>
              <v-list-tile-title class="body-1">
                <span class="caption grey--text pr-2 hidden-sm-and-down">开始时间</span>
                <span
                  class="mx-1"
                  v-if="rule.period === 'week'"
                >{{ $L.time.showWeekday(slice.startWeekday, 'short') }}</span>
                <span>{{ slice.startTime }}</span>
                <span class="mx-2">{{$vuetify.breakpoint.smAndDown ? '-' : ''}}</span>
                <span class="caption grey--text pr-2 hidden-sm-and-down">结束时间</span>
                <span
                  class="mx-1"
                  v-if="rule.period === 'week'"
                >{{ $L.time.showWeekday(slice.endWeekday, 'short') }}</span>
                <span>{{ slice.endTime }}</span>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile
            :key="parkingLot.id"
            v-for="parkingLot in slice.gateways"
          >
            <v-list-tile-content>
              <v-list-tile-title
                :class="[dark ? 'text--lighten-1':'text--darken-1', 'pl-2']"
                class="body-1 grey--text"
              >
                <v-layout row>
                  <v-flex class="hide-more-content" xs5>
                    <span class="caption grey--text pr-2">停车场区</span>
                    <span>{{ parkingLot.name }}</span>
                    <span class="mx-2"></span>
                  </v-flex>
                  <v-flex class="hide-more-content" xs7>
                    <v-tooltip bottom max-width="56em">
                      <div slot="activator">
                        <span class="caption grey--text pr-2">通行卡口</span>
                        <span v-if="isSelectAll(parkingLot.id, parkingLot.controllers)">全部通行卡口</span>
                        <span v-else>{{parkingLot.controllers.map(c => c.name).join('、')}}</span>
                      </div>
                      <span>{{parkingLot.controllers.map(c => c.name).join('、')}}</span>
                    </v-tooltip>

                  </v-flex>
                </v-layout>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-if="!slice.gateways || slice.gateways.length === 0">
            <v-list-tile-content class="grey--text pl-3">
              没有绑定通行关口
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
      </template>
      <template v-else>
        <v-list-tile
          :key="parkingLot.id"
          v-for="parkingLot in rule.gateways"
        >
          <v-list-tile-content>
            <v-list-tile-title
              class="body-1 pl-2"
            >
              <v-layout row>
                <v-flex class="hide-more-content" xs5>
                  <span class="caption grey--text pr-2">停车场区</span>
                  <span>{{ parkingLot.name }}</span>
                  <span class="mx-2"></span>
                </v-flex>
                <v-flex class="hide-more-content" xs7>
                  <v-tooltip bottom max-width="56em">
                    <div slot="activator">
                      <span class="caption grey--text pr-2">通行卡口</span>
                      <span v-if="isSelectAll(parkingLot.id, parkingLot.controllers)">全部通行卡口</span>
                      <span v-else>{{parkingLot.controllers.map(c => c.name).join('、')}}</span>
                    </div>
                    <span>{{parkingLot.controllers.map(c => c.name).join('、')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="!rule.gateways || rule.gateways.length === 0">
          <v-list-tile-content class="grey--text pl-3">
            没有绑定通行关口
          </v-list-tile-content>
        </v-list-tile>
      </template>
      <v-list-tile v-if="rule.ledPrompt"  v-show="showFlag">
        <v-list-tile-content>
          <v-list-tile-title
            class="pl-2 body-1"
          >
            <span class="caption grey--text pr-1">屏显提示</span>
            <span>{{ rule.ledPrompt }}</span>
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="rule.audioPrompt" v-show="showFlag">
        <v-list-tile-content>
          <v-list-tile-title
            class="pl-2 body-1"
          >
            <span class="caption grey--text pr-1">语音提示</span>
            {{ rule.audioPrompt }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="rule.ledPromptIn" v-show="showFlag">
        <v-list-tile-content>
          <v-list-tile-title
            class="pl-2 body-1"
          >
            <span class="caption grey--text pr-1">进场屏显</span>
            {{ rule.ledPromptIn }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="rule.audioPromptIn" v-show="showFlag">
        <v-list-tile-content>
          <v-list-tile-title
            class="pl-2 body-1"
          >
            <span class="caption grey--text pr-1">进场语音</span>
            {{ rule.audioPromptIn }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="rule.ledPromptOut" v-show="showFlag">
        <v-list-tile-content>
          <v-list-tile-title
            class="pl-2 body-1"
          >
            <span class="caption grey--text pr-1">出场屏显</span>
            {{ rule.ledPromptOut }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile v-if="rule.audioPromptOut" v-show="showFlag">
        <v-list-tile-content>
          <v-list-tile-title
            class="pl-2 body-1"
          >
            <span class="caption grey--text pr-1">出场语音</span>
            {{ rule.audioPromptOut }}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list-group>
    <v-list-tile v-if="passRules.length === 0">
      <v-list-tile-title class="grey--text text-xs-center body-2">没有{{prefixText}}</v-list-tile-title>
    </v-list-tile>
  </v-list>
</template>

<script>
import {F} from '@/ladmin'

export default {
  name: 'LPassRuleList',
  props: {
    specific: {
      type: Boolean,
      default: false
    },
    passRules: {
      type: Array,
      default: () => []
    },
    singleRule: {
      type: Boolean,
      default: false,
    },
    prefixText: {
      type: String,
      default: '规则'
    },
    passType: {
      type: String,
      default: 'vehicle'
    },
    showFlag:{
      type:Boolean,
      default:true
    },
    noIdent: {type: Boolean, default: false}
  },
  computed: {
    dark () {
      return this.$vuetify.dark
    },
    controllersGroup () {
      let controllers = (this.passType === 'vehicle') ? this.$store.state.parkingLot.controllerList || [] : this.$store.state.parkingLot.personControllerList || []
      return F.groupBy(controllers, 'parkingLotId')
    },
    isSelectAll () {
      return (pId, controllers) => {
        let p = this.controllersGroup[pId]
        if (p) {
          return p.length === controllers.length
        }
        return false
      }
    }
  }
}
</script>

<style scoped>
  .flat {
    box-shadow: none !important;
  }

  .hide-more-content {
    display: inline-block;
    overflow: hidden;
    vertical-align: middle;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
